import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceSupportWebsiteEditRoute: InvariantJiraRoute = {
	name: 'csm-experience-support-website-edit',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/support-website/edit/:pageId?',
	exact: true,
};
